export default () => ({
  title: "",
  total: "",
  indications:[],
  indication:null,
  indicationsToEdit: '',
  status: '',
});
